import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Landmark, Briefcase, TrendingUp, ArrowRight } from 'lucide-react';
export const Services = () => {
  const practices = [{
    slug: 'tax-and-accounting',
    title: 'Tax & Accounting',
    icon: <Landmark size={48} data-id="element-549" data-mp="3jjcmejgzuujr" />,
    color: 'bg-brand-navy',
    description: 'Precision-driven tax planning and accounting services for corporate and private wealth clients.',
    img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80'
  }, {
    slug: 'strategic-advisory',
    title: 'Strategic Advisory',
    icon: <Briefcase size={48} data-id="element-550" data-mp="b1ot5dljox9p" />,
    color: 'bg-brand-emerald',
    description: 'Comprehensive business strategy, market entry, and operational optimization for sustainable growth.',
    img: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80'
  }, {
    slug: 'consilium-capital',
    title: 'Consilium Capital',
    icon: <TrendingUp size={48} data-id="element-551" data-mp="16qe04ea1b5tn" />,
    color: 'bg-brand-gold',
    description: 'Navigating complex capital structures, debt advisory, and equity raising for ambitious enterprises.',
    img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80'
  }];
  return <main className="pt-24" data-id="element-552" data-mp="1khsj4l3xz70p">
      {/* Hero */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-553" data-mp="1pfkks6ue27i3">
        <div className="absolute inset-0 opacity-10" data-id="element-554" data-mp="1uef4db06k039">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/27559d20-56df-4ace-a32a-f1c2ddb34050.jpg')] bg-cover bg-center" data-id="element-555" data-mp="1ud43biy4d6fu" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-556" data-mp="23e27c18k5dyf">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-557" data-mp="91kpj96hn616">
            Our Expertise
          </span>
          <h1 className="text-5xl md:text-7xl font-display mb-8" data-id="element-558" data-mp="17cvem9ehwhbz">
            Comprehensive <br data-id="element-559" data-mp="17eztfmdxn0r1" />
            <span className="italic" data-id="element-560" data-mp="1lcocqpscpztz">Financial</span> Solutions.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-561" data-mp="1lajz3g4nhmgi">
            We provide a multidisciplinary approach to financial success,
            combining technical mastery with strategic insight across three core
            practices.
          </p>
        </motion.div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-brand-warm-white" data-id="element-562" data-mp="250dvk7ib8pr2">
        <div className="max-w-7xl mx-auto px-6" data-id="element-563" data-mp="24zucgngxbvbg">
          <div className="grid lg:grid-cols-3 gap-8" data-id="element-564" data-mp="2010zcw5ju6bt">
            {practices.map((practice, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: idx * 0.1
          }} className="group flex flex-col h-full" data-id="element-565" data-mp="2e0sg34nga0ti" data-mpi={idx}>
                <Link to={`/services/${practice.slug}`} className="bg-white rounded-[2rem] overflow-hidden shadow-xl border border-brand-navy/5 hover:shadow-2xl hover:border-brand-gold/30 transition-all duration-500 flex flex-col h-full" data-id="element-566" data-mp="2xmlp5y8jgdqr">
                  <div className="relative" data-id="element-567" data-mp="29wrf1oflt3a7">
                    <div className="h-64 overflow-hidden relative" data-id="element-568" data-mp="2eo9eg81zavt2">
                      <img src={practice.img} alt={practice.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-569" data-mp="2epkim8zc65kp" />
                      <div className="absolute inset-0 bg-brand-navy/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-570" data-mp="1qyf1zrlkn99c" />
                    </div>
                    <div className={`absolute -bottom-6 left-8 p-4 rounded-2xl text-white ${practice.color} shadow-lg z-10`} data-id="element-571" data-mp="1vzky7zefxenm">
                      {practice.icon}
                    </div>
                  </div>
                  
                  <div className="p-10 pt-14 flex flex-col flex-grow" data-id="element-572" data-mp="1e6r0cf4j3d8m">
                    <h2 className="text-3xl font-display text-brand-navy mb-4 group-hover:text-brand-gold transition-colors" data-id="element-573" data-mp="1e4wixasgu39a">
                      {practice.title}
                    </h2>
                    <p className="text-brand-charcoal/70 leading-relaxed mb-8 flex-grow" data-id="element-574" data-mp="154hva4s14c2m">
                      {practice.description}
                    </p>
                    <div className="inline-flex items-center gap-3 text-brand-navy font-bold tracking-widest uppercase text-xs border-b-2 border-brand-gold pb-2 group-hover:gap-5 transition-all self-start mt-auto" data-id="element-575" data-mp="v9g6ja1o1c0k">
                      Explore Services <ArrowRight size={16} className="text-brand-gold" data-id="element-576" data-mp="2pkbmwyj3dvdw" />
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-brand-navy text-white overflow-hidden" data-id="element-577" data-mp="cbcwguzmmzpo">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto px-6 text-center" data-id="element-578" data-mp="h2uvvem04s8j">
          <h2 className="text-4xl md:text-5xl font-display mb-8" data-id="element-579" data-mp="3klfultz3k1ov">
            Ready to navigate your <br data-id="element-580" data-mp="3pj7xfj1a587u" />
            <span className="italic text-brand-gold" data-id="element-581" data-mp="3pksgabe8f2pv">financial future?</span>
          </h2>
          <p className="text-white/60 text-lg mb-12" data-id="element-582" data-mp="3tiyir781ew4z">
            Our partners are available for a strategic consultation to discuss
            your specific goals.
          </p>
          <Link to="/contact" className="inline-block bg-brand-gold text-white px-10 py-5 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-brand-navy transition-all" data-id="element-583" data-mp="18t94owf5redc">
            Schedule a Consultation
          </Link>
        </motion.div>
      </section>
    </main>;
};